import { apiFetch } from 'api/client';

const postLogs = async (path, payload, signal) => {
    const response = await apiFetch(`/auth/logs/${path}`, {
        method: 'POST',
        json: payload,
        signal,
    });
    if (!response.ok) {
        const fallback = `VictoriaLogs request failed (${response.status})`;
        const body = await response.text();
        let message = body.trim() || fallback;
        try {
            const parsed = JSON.parse(body);
            message = parsed?.error || parsed?.message || fallback;
        } catch {
            // VictoriaLogs returns useful plain-text LogsQL validation errors.
        }
        throw new Error(message);
    }
    return response;
};

export const queryLogs = async (payload, signal) => {
    const response = await postLogs('query', payload, signal);
    return response.text();
};

export const queryLogHits = async (payload, signal) => {
    const response = await postLogs('hits', payload, signal);
    return response.text();
};

export const queryLogFacets = async (payload, signal) => {
    const response = await postLogs('facets', payload, signal);
    return response.text();
};

export const tailLogs = (payload, signal) => postLogs('tail', payload, signal);

export const parseLogStreamLine = (line) => {
    const trimmed = String(line || '').trim();
    if (!trimmed) return [];

    const payload = trimmed.startsWith('data:') ? trimmed.slice(5).trim() : trimmed;
    if (!payload || payload === '[DONE]') return [];

    try {
        const parsed = JSON.parse(payload);
        return Array.isArray(parsed) ? parsed : [parsed];
    } catch {
        // Ignore malformed upstream lines without terminating a live stream.
        return [];
    }
};

export const consumeNDJSONStream = async (response, onEntry) => {
    if (!response.body) {
        throw new Error('Streaming responses are not supported by this browser.');
    }
    const reader = response.body.getReader();
    const decoder = new TextDecoder();
    let buffer = '';

    const emitLine = (line) => {
        parseLogStreamLine(line).forEach(onEntry);
    };

    try {
        while (true) {
            const { done, value } = await reader.read();
            buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
            const lines = buffer.split(/\r?\n/);
            buffer = lines.pop() || '';
            lines.forEach(emitLine);
            if (done) break;
        }

        emitLine(buffer);
    } finally {
        reader.releaseLock?.();
    }
};
